import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/layouts/PublicLayout";
import { api } from "@/lib/api";
import { Megaphone, Users, ArrowRight } from "lucide-react";

export default function PetitionsList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/petitions").then((r) => setItems(r.data || [])).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="relative overflow-hidden bg-gradient-to-br from-wine-50 via-amber-50 to-white py-16">
        <div className="mx-auto max-w-6xl px-6 md:px-8">
          <div className="inline-flex items-center gap-2 rounded-full bg-wine-100 px-4 py-1 text-xs font-bold uppercase tracking-wider text-wine-700"><Megaphone className="h-3.5 w-3.5" /> Soutenez-nous</div>
          <h1 className="mt-4 font-serif text-4xl text-navy md:text-6xl">Faisons bouger la filière, ensemble.</h1>
          <p className="mt-4 max-w-2xl text-lg text-neutral-700">Pétitions, prises de position, mouvements collectifs : signez les causes qui font avancer la WineTech française. Chaque signature compte — partagez aussi pour amplifier l&apos;impact.</p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-12 md:px-8">
        {items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-neutral-200 bg-white p-12 text-center" data-testid="petitions-empty">
            <Megaphone className="mx-auto h-10 w-10 text-neutral-300" />
            <p className="mt-3 text-neutral-500">Aucune pétition en cours pour le moment.</p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {items.map((p) => (
              <Link key={p.id} to={`/soutenez-nous/${p.slug}`} className="group overflow-hidden rounded-2xl border border-neutral-100 bg-white transition hover:shadow-xl" data-testid={`petition-card-${p.id}`}>
                {p.cover_image ? (
                  <img src={p.cover_image} alt={p.title} className="aspect-[16/9] w-full object-cover transition group-hover:scale-105" />
                ) : (
                  <div className="grid aspect-[16/9] w-full place-items-center bg-gradient-to-br from-wine-100 to-amber-100">
                    <Megaphone className="h-16 w-16 text-wine-400" />
                  </div>
                )}
                <div className="p-6">
                  <h3 className="font-serif text-xl text-navy group-hover:text-wine-600">{p.title}</h3>
                  <p className="mt-2 line-clamp-3 text-sm text-neutral-600">{(p.description || "").replace(/[#*_>`]/g, "").slice(0, 160)}…</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-wine-700"><Users className="h-3.5 w-3.5" />{p.signatures_count} signataire{p.signatures_count > 1 ? "s" : ""}</span>
                    <span className="inline-flex items-center gap-1 text-sm font-bold text-wine-700 group-hover:gap-2 transition-all">Soutenir <ArrowRight className="h-4 w-4" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
